import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import GitHubLogo from '../github-logo';
import SectionOne from './templates/section-one'
import SectionTwo from './templates/section-two'

import './content-section.css';

const ContentSection = ({authenticated, signOut}) => (
		<div className="steps landing__section">
			<SectionOne/>
			<SectionTwo/>
		</div>
);


export default ContentSection;



// WEBPACK FOOTER //
// ./src/views/components/content-section/content-section.js